import type { ComputedRef, Ref } from 'vue';
import { unref } from 'vue';
import { useShipmentFormStore } from '@/stores/useShipmentFormStore';

type PersistDevicesDeps = {
  postDevices: (args: {
    accountId: number;
    shipmentId: number;
    payload: { device_ids: number[] };
  }) => Promise<unknown>;
  publishShipment: (args: {
    accountId: number;
    shipmentId: number;
  }) => Promise<unknown>;
};

export async function persistFormDevices(
  deps: PersistDevicesDeps,
  options: {
    accountId: Ref<number> | ComputedRef<number>;
    shipmentId: Ref<number | null> | ComputedRef<number | null>;
  },
  deviceIds: readonly number[],
) {
  const sid = unref(options.shipmentId);
  if (sid == null) {
    throw new Error('Missing shipment id');
  }
  if (deviceIds.length === 0) {
    throw new Error('At least one tracker is required');
  }

  await deps.postDevices({
    accountId: unref(options.accountId),
    shipmentId: sid,
    payload: { device_ids: [...deviceIds] },
  });

  const formStore = useShipmentFormStore();
  formStore.markDeviceIdsPersisted(deviceIds);
}

export async function publishFormShipment(
  deps: Pick<PersistDevicesDeps, 'publishShipment'>,
  options: {
    accountId: Ref<number> | ComputedRef<number>;
    shipmentId: Ref<number | null> | ComputedRef<number | null>;
  },
) {
  const sid = unref(options.shipmentId);
  if (sid == null) {
    throw new Error('Missing shipment id');
  }

  await deps.publishShipment({
    accountId: unref(options.accountId),
    shipmentId: sid,
  });
}
